


















































































import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import { Utilities as utils } from "@/shared/utilities";
import HeaderInfo from '@/components/App/Modules/GMS/Grants/ExpansionPanel/ExpansionPanel.vue';
import ReportPeriodEditor from './ReportPeriodEditor.vue';
import PermissionService from '@/services/permission.service';
import { IGrant } from "@/entities";

const permissionService = new PermissionService();
const namespace: string = "grant";

@Component({
    components: {
        HeaderInfo,
        ReportPeriodEditor
    }
})
export default class FinancialReports extends Vue {
    @Getter("readGrant", { namespace }) grant: IGrant;
    @Action("startFinancialReport", { namespace: 'financialReport'}) startFinancialReport: any;
    @Action("updateReportPeriod", { namespace: 'financialReport' }) updateFinancialReport: any;
    @Prop() grantId: number;
    @Prop() reports: any;

    search: string = '';
    documents: any = [];
    headers: any = [];
    dialog: boolean = false;
    doc: any = {};
    docTags: any = [];
    actions = _app.actions;
    subjects = _app.subjects;
    finReportStatus = _app.finReportStatus;
    finReportAuditStatus = _app.finReportAuditStatus;
    editDialog: boolean = false;
    selectedReport: any = {};
    editIcon = 'mdi-pencil-outline';
    title = 'Edit';
    ppoAccess:boolean = false;
    initiativeId:number = 0;

    /** mounted fn */
    mounted() {
        this.initiativeId = this.grant.InitiativeId;
        this.headers = _app.reportingPeriodHeaders;
        this.headers.map(x => {
            x.text = this.$t(x.text);
        });
    }

    formatDate(dt: any) {
        return utils.formatDate(dt);
    }

    /** edit the period */
    editPeriod(item: any) {
        this.selectedReport = item;
        this.editDialog = true;
    }

    closeDialog() {
        this.selectedReport = {};
        this.editDialog = false;
    }

    updatePeriod() {
        let id = this.selectedReport.FinancialReportId;
        this.updateFinancialReport({ id, data: this.selectedReport })
        .then((data) => {
            this.selectedReport = {};
            this.editDialog = false;
        })
    }

    /** edit the selected item */
    editItem(item: any) {
        let reportId = item.FinancialReportId.toString();
        // #. if not started, then start the report and navigate.
        if(item.WorkFlowStatusId === this.finReportStatus.notStarted || item.WorkFlowStatusId === this.finReportAuditStatus.notStarted) {
            this.startFinancialReport(item.FinancialReportId)
            .then((resp) => {
                if (resp) {
                    this.$router.push({
                        name: "financialReport",
                        params: { financialReportId: reportId, reportLength: this.reports.length }
                    });
                }
            });
        } else {
            this.$router.push({
                name: "financialReport",
                params: { financialReportId: reportId, reportLength: this.reports.length }
            });
        }
        
    }

    checkPermission(item: any, btn: string) {
        switch(btn) {
            case 'edit': {
                //@ts-ignore
                if(this.$can(this.actions.read, this.subjects.grantReports) && (item.WorkFlowStatusId !== this.finReportStatus.notStarted || item.WorkFlowStatusId !== this.finReportAuditStatus.notStarted))
                {
                    this.editIcon = 'mdi-file-search-outline';
                    this.title = 'View';
                    return true;
                }
                //@ts-ignore
                else if(this.$can(this.actions.read, this.subjects.grantReports) && (item.WorkFlowStatusId === this.finReportStatus.notStarted || item.WorkFlowStatusId === this.finReportAuditStatus.notStarted))
                {   
                    return false; // admins should not start reporting (Bug #294971)
                }
                //@ts-ignore
                else if(this.$can(this.actions.update, this.subjects.grantReports))
                    return true;
            }
            break;
            case 'edit-period': {
                //@ts-ignore
                if((this.$can(this.actions.manage, this.subjects.periodEdit) || this.ppoAccess) && (item.WorkFlowStatusId === this.finReportStatus.inProgress || item.WorkFlowStatusId === this.finReportAuditStatus.inProgress))
                    return true;
            }
        }
    }

    @Watch("initiativeId")
    enableButton(val: any) {
        if (val) {
            this.ppoHasPermission(val);
        } else {
            this.ppoAccess = false;
        }
    }

    ppoHasPermission(initiativeId) {
        // Get logged in user initiatives
        permissionService.ppoHasPermission(initiativeId).then((hasPermission: boolean) => {
            // get user initiaive
            this.ppoAccess = hasPermission;
        });
    }

    // buttonVisibility(item: any) {
    //     //@ts-ignore
    //     if(this.$can(this.actions.read, this.subjects.grantReports) &&
    //          item.WorkFlowStatusId === this.finReportStatus.pendingReview) {
    //         // secratariat users with just review only roles can only edit pending for review records
    //         return true;
    //     }
    //     //@ts-ignore
    //     else if(this.$can(this.actions.manage, this.subjects.grantReports)) {
    //         return true;
    //     }
    // }
}
